(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"), require("@material/react-tab-indicator/dist/index.js"), require("@material/tab/dist/mdc.tab.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js", "@material/react-tab-indicator/dist/index.js", "@material/tab/dist/mdc.tab.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"), require("@material/react-tab-indicator/dist/index.js"), require("@material/tab/dist/mdc.tab.js")) : factory(root["react"], root["classnames"], root["@material/react-ripple/dist/index.js"], root["@material/react-tab-indicator/dist/index.js"], root["@material/tab/dist/mdc.tab.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_82__, __WEBPACK_EXTERNAL_MODULE_83__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 81);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      0:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/
      },

      /***/
      1:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
        /***/
      },

      /***/
      2:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
        /***/
      },

      /***/
      81:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __extends = this && this.__extends || function () {
          var _extendStatics = function extendStatics(d, b) {
            _extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics(d, b);
          };

          return function (d, b) {
            _extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames = __webpack_require__(1);

        var react_tab_indicator_1 = __webpack_require__(82); // @ts-ignore No mdc .d.ts files


        var mdc_tab_1 = __webpack_require__(83);

        var TabRipple_1 = __webpack_require__(84);

        exports.TabRipple = TabRipple_1.default;

        var Tab =
        /** @class */
        function (_super) {
          __extends(Tab, _super);

          function Tab() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.tabRef = React.createRef();
            _this.tabContentRef = React.createRef();
            _this.tabIndicatorRef = React.createRef();
            _this.tabRippleRef = React.createRef();
            _this.state = {
              'classList': new Set(),
              'aria-selected': false,
              'activateIndicator': false,
              'previousIndicatorClientRect': _this.props.previousIndicatorClientRect
            };

            _this.computeIndicatorClientRect = function () {
              if (!_this.tabIndicatorRef.current) return;
              return _this.tabIndicatorRef.current.computeContentClientRect();
            };

            _this.computeDimensions = function () {
              return _this.foundation.computeDimensions();
            };

            _this.focus = function () {
              _this.tabRef.current && _this.tabRef.current.focus();
            };

            _this.onFocus = function (e) {
              _this.tabRippleRef.current && _this.tabRippleRef.current.handleFocus(e);
            };

            _this.onBlur = function (e) {
              _this.tabRippleRef.current && _this.tabRippleRef.current.handleBlur(e);
            };

            return _this;
          }

          Tab.prototype.componentDidMount = function () {
            this.foundation = new mdc_tab_1.MDCTabFoundation(this.adapter);
            this.foundation.init();

            if (this.props.active) {
              this.foundation.activate();
            }
          };

          Tab.prototype.componentWillUnmount = function () {
            this.foundation.destroy();
          };

          Tab.prototype.componentDidUpdate = function (prevProps) {
            if (this.props.active !== prevProps.active) {
              if (this.props.active) {
                // If active state is updated through props, previousIndicatorClientRect must also be passed through props
                this.activate(this.props.previousIndicatorClientRect);
              } else {
                this.deactivate();
              }
            }
          };

          Object.defineProperty(Tab.prototype, "classes", {
            get: function get() {
              var classList = this.state.classList;
              var _a = this.props,
                  className = _a.className,
                  minWidth = _a.minWidth,
                  stacked = _a.stacked;
              return classnames('mdc-tab', Array.from(classList), className, {
                'mdc-tab--min-width': minWidth,
                'mdc-tab--stacked': stacked
              });
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(Tab.prototype, "adapter", {
            get: function get() {
              var _this = this;

              return {
                addClass: function addClass(className) {
                  var classList = new Set(_this.state.classList);
                  classList.add(className);

                  _this.setState({
                    classList: classList
                  });
                },
                removeClass: function removeClass(className) {
                  var classList = new Set(_this.state.classList);
                  classList.delete(className);

                  _this.setState({
                    classList: classList
                  });
                },
                hasClass: function hasClass(className) {
                  return _this.classes.split(' ').includes(className);
                },
                setAttr: function setAttr(attr, value) {
                  return _this.setState(function (prevState) {
                    var _a;

                    return __assign({}, prevState, (_a = {}, _a[attr] = value, _a));
                  });
                },
                getOffsetLeft: function getOffsetLeft() {
                  return Number(_this.tabRef.current && _this.tabRef.current.offsetLeft);
                },
                getOffsetWidth: function getOffsetWidth() {
                  return Number(_this.tabRef.current && _this.tabRef.current.offsetWidth);
                },
                getContentOffsetLeft: function getContentOffsetLeft() {
                  return _this.tabContentRef.current && _this.tabContentRef.current.offsetLeft;
                },
                getContentOffsetWidth: function getContentOffsetWidth() {
                  return _this.tabContentRef.current && _this.tabContentRef.current.offsetWidth;
                },
                focus: function focus() {
                  return _this.tabRef.current && _this.tabRef.current.focus();
                },
                activateIndicator: function activateIndicator(previousIndicatorClientRect) {
                  return _this.setState({
                    activateIndicator: true,
                    previousIndicatorClientRect: previousIndicatorClientRect
                  });
                },
                deactivateIndicator: function deactivateIndicator() {
                  return _this.setState({
                    activateIndicator: false
                  });
                }
              };
            },
            enumerable: true,
            configurable: true
          });

          Tab.prototype.activate = function (computeIndicatorClientRect) {
            this.foundation.activate(computeIndicatorClientRect);
          };

          Tab.prototype.deactivate = function () {
            this.foundation.deactivate();
          };

          Tab.prototype.render = function () {
            var _a = this.props,

            /* eslint-disable */
            active = _a.active,
                previousIndicatorClientRect = _a.previousIndicatorClientRect,
                className = _a.className,
                isFadingIndicator = _a.isFadingIndicator,
                indicatorContent = _a.indicatorContent,
                minWidth = _a.minWidth,
                stacked = _a.stacked,

            /* eslint-enable */
            children = _a.children,
                isMinWidthIndicator = _a.isMinWidthIndicator,
                otherProps = __rest(_a, ["active", "previousIndicatorClientRect", "className", "isFadingIndicator", "indicatorContent", "minWidth", "stacked", "children", "isMinWidthIndicator"]);

            var _b = this.state,
                tabIndex = _b.tabIndex,
                ariaSelected = _b["aria-selected"];
            return React.createElement("button", __assign({
              className: this.classes,
              role: 'tab',
              "aria-selected": ariaSelected,
              tabIndex: tabIndex,
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              ref: this.tabRef
            }, otherProps), React.createElement("span", {
              className: 'mdc-tab__content',
              ref: this.tabContentRef
            }, children, isMinWidthIndicator ? this.renderIndicator() : null), isMinWidthIndicator ? null : this.renderIndicator(), React.createElement(TabRipple_1.default, {
              ref: this.tabRippleRef
            }));
          };

          Tab.prototype.renderIndicator = function () {
            var _a = this.props,
                isFadingIndicator = _a.isFadingIndicator,
                indicatorContent = _a.indicatorContent;
            var _b = this.state,
                activateIndicator = _b.activateIndicator,
                previousIndicatorClientRect = _b.previousIndicatorClientRect;
            return React.createElement(react_tab_indicator_1.default, {
              icon: !!indicatorContent,
              fade: isFadingIndicator,
              active: activateIndicator,
              previousIndicatorClientRect: previousIndicatorClientRect,
              ref: this.tabIndicatorRef
            }, indicatorContent);
          };

          Tab.defaultProps = {
            active: false,
            className: '',
            isFadingIndicator: false,
            indicatorContent: null,
            minWidth: false,
            isMinWidthIndicator: false,
            stacked: false
          };
          return Tab;
        }(React.Component);

        exports.Tab = Tab;
        exports.default = Tab;
        /***/
      },

      /***/
      82:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_82__;
        /***/
      },

      /***/
      83:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_83__;
        /***/
      },

      /***/
      84:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __extends = this && this.__extends || function () {
          var _extendStatics2 = function extendStatics(d, b) {
            _extendStatics2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics2(d, b);
          };

          return function (d, b) {
            _extendStatics2(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames_1 = __webpack_require__(1);

        var Ripple = __webpack_require__(2);

        var TabRippleBase =
        /** @class */
        function (_super) {
          __extends(TabRippleBase, _super);

          function TabRippleBase() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          Object.defineProperty(TabRippleBase.prototype, "classes", {
            get: function get() {
              return classnames_1.default('mdc-tab__ripple', this.props.className);
            },
            enumerable: true,
            configurable: true
          });

          TabRippleBase.prototype.render = function () {
            var _a = this.props,
                // keeping out of ...otherProps

            /* eslint-disable no-unused-vars */
            className = _a.className,
                unbounded = _a.unbounded,

            /* eslint-enable no-unused-vars */
            initRipple = _a.initRipple,
                otherProps = __rest(_a, ["className", "unbounded", "initRipple"]);

            return React.createElement("div", __assign({
              className: this.classes
            }, otherProps, {
              ref: initRipple
            }));
          };

          return TabRippleBase;
        }(React.Component);

        var TabRipple = Ripple.withRipple(TabRippleBase);
        exports.default = TabRipple;
        /***/
      }
      /******/

    })
  );
});